import { useEffect, useState } from 'preact/hooks';

import { useVideoElement } from './useVideoElement';

export const usePlaybackCountdown = (initialState: number) => {
  const videoElement = useVideoElement();
  const [remainingTime, setRemainingTime] = useState(initialState);

  useEffect(() => {
    if (!videoElement) {
      return;
    }

    let requestId: number;

    const update = () => {
      const { currentTime, duration } = videoElement;

      setRemainingTime(duration - currentTime);

      requestId = requestAnimationFrame(update);
    };

    requestId = requestAnimationFrame(update);

    return () => cancelAnimationFrame(requestId);
  }, [videoElement]);

  return { remainingTime };
};
